import PropTypes from 'prop-types';
// @mui
import { Paper, List, ListItem, Typography, Box, Link } from '@mui/material';

// A simple list component to show "intensives" on the right column.
export default function IntensiveList({ intensives = [] }) {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6">Інтенсиви</Typography>
      </Box>
      <List>
        {intensives && intensives.length > 0 ? (
          intensives.map((item, idx) => {
            const title = item.name || item.title || `Інтенсив ${idx + 1}`;
            const info = item.info || null;
            const presentation = item.teacher_material || item.teacher_material2 || null;

            return (
              <ListItem key={item.id || idx} divider sx={{ py: 1 }}>
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
                  <Box sx={{ pr: 2, minWidth: 0, flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <Typography noWrap variant="subtitle1" sx={{ pr: 2, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {title}
                      </Typography>
                      {presentation ? (
                        <Link
                          href={presentation}
                          target="_blank"
                          rel="noopener noreferrer"
                          underline="hover"
                          variant="body2"
                          sx={{ ml: 1, flex: '0 0 auto' }}
                        >
                          Презентація
                        </Link>
                      ) : null}
                    </Box>

                    {info ? (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {info}
                      </Typography>
                    ) : null}
                  </Box>
                </Box>
              </ListItem>
            );
          })
        ) : (
          <ListItem>
            <Typography>Немає інтенсивів</Typography>
          </ListItem>
        )}
      </List>
    </Paper>
  );
}

IntensiveList.propTypes = {
  intensives: PropTypes.array,
};
